import { Breakpoint, BreakpointsOptions } from "@mui/material";

export type TParseBreakpoints = (
  localeConfig?: Partial<{ [key in Breakpoint]: number }>,
  remoteConfig?: Partial<{ [key in Breakpoint]: number }>,
) => BreakpointsOptions | undefined;

export const parseBreakpoints: TParseBreakpoints = (
  localeConfig,
  remoteConfig,
) => {
  if (!localeConfig && !remoteConfig) return undefined;
  const lkeys = Object.keys(localeConfig || {}) as Array<Breakpoint>;
  const rkeys = Object.keys(remoteConfig || {}) as Array<Breakpoint>;
  const breakpoints = [...rkeys, ...lkeys].reduce((acc, key) => {
    return {
      ...acc,
      [key]: remoteConfig?.[key] ?? localeConfig?.[key],
    };
  }, {});
  return breakpoints;
};
